<template>
  <div>
    <v-toolbar color="transparent" flat light>
      <v-btn-toggle
        style="margin-left: -8px"
        outline
        v-model="displayType"
        @change="onDisplayType"
        v-if="groups.length>0"
      >
        <v-btn :value="DISPLAY_TYPE_GROUP" flat>
          <v-icon>view_module</v-icon>
        </v-btn>
        <v-btn :value="DISPLAY_TYPE_LIST" flat>
          <v-icon>list</v-icon>
        </v-btn>
      </v-btn-toggle>
      <div style="padding-left: 4px; padding-right: 4px; height: 34px;">
        <v-text-field
          v-if="fulltextSearch"
          hide-details
          single-line
          small
          label="Volltextsuche"
          outline
          prepend-inner-icon="search"
          clearable
          pl-4
          pr-4
          style="height: 34px !important; min-height: 34px !important;"
        />
      </div>

      <v-btn @click.stop="openFilterDrawer" v-if="filter" outline color="secondary">
        <v-badge left color="secondary">
          <template v-slot:badge v-if="settings.filter_by.length">
            <span>{{settings.filter_by.length}}</span>
          </template>

          <v-icon>filter_list</v-icon>
        </v-badge>
        <span class="hidden-sm-and-down">Filtern</span>
      </v-btn>

      <v-btn @click.stop="openSortDrawer" v-if="sort" outline color="secondary">
        <v-badge left color="secondary">
          <template v-slot:badge v-if="settings.sort_by.length">
            <span>{{settings.sort_by.length}}</span>
          </template>
          <v-icon>sort</v-icon>
        </v-badge>
        <span class="hidden-sm-and-down">Sortieren</span>
      </v-btn>

      <v-spacer />

      <MoreMenu v-if="actions.length" :items="actions" @on-action="onAction" />

      <template slot="extension" v-if="displayType === DISPLAY_TYPE_GROUP">
        <v-btn icon @click="settings.grouped_by.desc = !settings.grouped_by.desc" color="primary">
          <v-icon v-if="settings.grouped_by.desc">arrow_upward</v-icon>
          <v-icon v-else>arrow_downward</v-icon>
        </v-btn>

        <v-menu offset-y>
          <v-btn depressed outline color="secondary" slot="activator">
            {{ groups.find( g=> g.value == settings.grouped_by.id).text }}
            <v-icon right dark>arrow_drop_down</v-icon>
          </v-btn>

          <v-list>
            <v-list-tile
              v-for="item in groups"
              :key="item.value"
              @click="settings.grouped_by.id = item.value"
            >
              <v-list-tile-title>{{ item.text }}</v-list-tile-title>
            </v-list-tile>
          </v-list>
        </v-menu>

        <v-spacer />

        <v-btn icon dark @click="onExpandAll" color="primary">
          <v-icon v-if="group.expandAll">unfold_less</v-icon>
          <v-icon v-else>unfold_more</v-icon>
        </v-btn>
      </template>
    </v-toolbar>
    <v-navigation-drawer v-model="drawer" temporary right app clipped fixed width="330">
      <v-toolbar dark color="secondary">
        <v-btn icon color="primary" @click.stop="drawer = !drawer">
          <v-icon>chevron_right</v-icon>
        </v-btn>

        <v-toolbar-title>{{drawerTitle[drawerType]}}</v-toolbar-title>
      </v-toolbar>

      <div v-if="drawerType == DRAWER_TYPE_FILTER">
        <div v-if="aggregations">
          <v-divider />

          <v-card flat pa-2>
            <span v-for="facet in aggregations" :key="facet.id">
              <template v-if="filters[facet.id] && filters[facet.id].length">
                <v-chip
                  v-for="(id, idx) in filters[facet.id]"
                  :key="idx"
                  close
                  @input="unselectBucket(facet.id, id)"
                  color="primary"
                  :title="facet.name + ' - ' +  facetName(facet.id, id)"
                >{{ facetName(facet.id, id) | trim(36) }}</v-chip>
              </template>
            </span>
          </v-card>
        </div>
        <v-card flat pa-2>
          <v-list dense>
            <v-list-group v-for="facet in aggregations" :key="facet.id">
              <v-list-tile slot="activator">
                <v-list-tile-content>
                  <v-list-tile-title
                    style="white-space: nowrap;"
                  >{{ facet.name }} ({{facet.buckets.length}})</v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>

              <v-list-tile v-for="bucket in facet.buckets" :key="bucket.id">
                <v-list-tile-action>
                  <v-checkbox v-model="filters[facet.id]" :value="bucket.id" multiple></v-checkbox>
                </v-list-tile-action>

                <v-list-tile-content
                  style="white-space: nowrap;"
                  :title="`${bucket.label} (${bucket.resultCount})`"
                >{{ bucket.label }} ({{bucket.resultCount}})</v-list-tile-content>
              </v-list-tile>
            </v-list-group>
          </v-list>
        </v-card>
      </div>
      <div v-else>
        <v-divider />
        <div v-if="this.settings.sort_by.length">
          <v-card flat pa-2>
            <span v-for="sorter in this.settings.sort_by" :key="sorter.id">
              <v-chip close @input="removeSortBy(sorter.id)" color="primary">
                <v-avatar>
                  <v-btn flat icon small @click="pushSortBy(sorter.id, !sorter.desc)">
                    <v-icon v-if="sorter.desc">arrow_upward</v-icon>
                    <v-icon v-else>arrow_downward</v-icon>
                  </v-btn>
                </v-avatar>
                {{ sorterName( sorter.id ) }}
              </v-chip>
            </span>
          </v-card>
        </div>
        <v-card flat pa-2>
          <v-list dense>
            <v-list-tile v-for="sorter in this.manipulators.sort_by" :key="sorter.id">
              <v-list-tile-action>
                <v-btn icon @click="pushSortBy(sorter.id, false)">
                  <v-icon>arrow_downward</v-icon>
                </v-btn>
              </v-list-tile-action>
              <v-list-tile-action>
                <v-btn icon @click="pushSortBy(sorter.id, true)">
                  <v-icon>arrow_upward</v-icon>
                </v-btn>
              </v-list-tile-action>

              <v-list-tile-content>
                <v-list-tile-title>{{ sorter.name }}</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
          </v-list>
        </v-card>
      </div>
    </v-navigation-drawer>
  </div>
</template>

<script>
import FormattingMixin from "@/components/mixins/FormattingMixin.vue";
import MoreMenu from "@/components/snippets/MoreMenu.vue";

import Vue from "vue";
import _ from "lodash";

const DISPLAY_TYPE_LIST = "list";
const DISPLAY_TYPE_GROUP = "group";

const DRAWER_TYPE_FILTER = "filter";
const DRAWER_TYPE_SORT = "sort";

export default {
  name: "GroupableItemListHeader",
  props: {
    listItems: {
      type: Object,
      required: false,
      default: () => ({})
    },
    fulltextSearch: {
      type: Boolean,
      default: false
    },
    defaultGrouping: {
      type: Object,
      default: null
    },
    defaultSorting: {
      type: Array,
      default: () => []
    },
    defaultFilter: {
      type: Object,
      default: () => ({})
    },

    filter: {
      type: Boolean,
      default: true
    },
    sort: {
      type: Boolean,
      default: true
    },
    manipulators: {
      type: Object,
      required: true
      //default: () => ({ filter_by: [], sort_by: [], group_by: [] })
    },
    aggregations: {
      type: Array,
      required: true
    },
    actions: {
      type: Array,
      default: () => []
    }
  },
  mixins: [FormattingMixin],
  components: { MoreMenu },
  data() {
    return {
      DISPLAY_TYPE_LIST,
      DISPLAY_TYPE_GROUP,
      DRAWER_TYPE_FILTER,
      DRAWER_TYPE_SORT,
      displayType:
        this.defaultGrouping === null ? DISPLAY_TYPE_LIST : DISPLAY_TYPE_GROUP,
      drawer: false,
      drawerType: DRAWER_TYPE_FILTER,
      drawerTitle: {
        filter: "Filtern",
        sort: "Sortieren"
      },
      group: {
        by: this.defaultGrouping === null ? null : this.defaultGrouping.id,
        desc: this.defaultGrouping === null ? false : this.defaultGrouping.desc,
        expandAll: false
      },
      filters: this.defaultFilter,
      settings: {
        filter_by: [],
        sort_by: this.defaultSorting,
        grouped_by: this.defaultGrouping
      }
    };
  },

  methods: {
    openFilterDrawer() {
      this.drawerType = "filter";
      this.drawer = true;
    },
    openSortDrawer() {
      this.drawerType = "sort";
      this.drawer = true;
    },
    onDisplayType(value) {
      if (value === DISPLAY_TYPE_LIST) {
        this.settings.grouped_by = null;
      } else {
        if (this.group.by === null) {
          this.group.by = this.manipulators.grouped_by[0].id;
        }
        this.settings.grouped_by = {
          id: this.group.by,
          desc: this.group.desc
        };
      }
    },
    onExpandAll() {
      this.group.expandAll = !this.group.expandAll;
      this.$emit("expand-all", this.group.expandAll);
    },
    unselectBucket(facetId, Id) {
      const idx = this.filters[facetId].findIndex(v => v === Id);
      if (idx >= 0) {
        Vue.delete(this.filters[facetId], idx);
      }
    },
    pushSortBy(id, desc) {
      const sorter = this.settings.sort_by.find(v => v.id == id);
      if (sorter) {
        sorter.desc = desc;
      } else {
        this.settings.sort_by.unshift({ id, desc });
      }
    },
    removeSortBy(id) {
      const sorter_idx = this.settings.sort_by.findIndex(v => v.id == id);
      if (sorter_idx >= 0) {
        this.settings.sort_by.splice(sorter_idx, 1);
      }
    },
    sorterName(id) {
      const sorter = this.manipulators.sort_by.find(v => v.id == id);
      if (sorter) {
        return sorter.name;
      } else {
        return id;
      }
    },
    onAction(action) {
      return this.$emit("on-action", action);
    },
    facetName(FacetId, FilterId) {
      const aggregation = this.aggregations.find(v => v.id == FacetId);
      if (aggregation) {
        const bucket = aggregation.buckets.find(v => v.id == FilterId);
        if (bucket) {
          return bucket.label;
        }
      }
      return FilterId;
    }
  },
  watch: {
    settings: {
      deep: true,
      immediate: true,
      handler(val) {
        this.$emit("change", val);
      }
    },
    filters: {
      deep: true,
      immediate: true,
      handler(newFilters) {
        const filter_by = _.map(newFilters, (v, i) => {
          return {
            id: i,
            params: v
          };
        });
        this.settings.filter_by = filter_by.filter(
          v => v.params instanceof Array && v.params.length
        );
      }
    }
  },
  computed: {
    groups() {
      const groups = [];
      for (const group_by of this.manipulators.grouped_by) {
        groups.push({ value: group_by.id, text: group_by.name });
      }
      return groups;
    }
  }
};
</script>
